import {
  AlertDetail,
  AlertIconListViewConfig,
  AlertIconType,
} from "components/portfolio/components/alert/alert-icon-type";
import moment from "moment";
import { ArrowDownward } from "@mui/icons-material";

const SHARED_CONFIG: AlertIconListViewConfig<AlertDetail>[] = [
  {
    label: "Date",
    colId: "createdDate",
    valueFormatter: function (value) {
      return moment(value).format("MM/DD/YYYY");
    },
  },
  { label: "Issues", colId: "name" },
];

export const getAlertIconListViewConfig = (
  type: AlertIconType
): AlertIconListViewConfig<AlertDetail>[] => {
  switch (type) {
    case "CHURN_RISK":
      return [...SHARED_CONFIG, { label: "Subscription Id", colId: "referenceId" }];
    case "USAGE":
      return [
        ...SHARED_CONFIG,
        {
          label: "Declined by",
          colId: "changeRate",
          valueFormatter: (value: string) => (
            <>
              <ArrowDownward style={{ fontSize: "1rem" }} />{" "}
              {Math.abs(+value * 100).toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              })}
              %
            </>
          ),
          valueStyle: { color: "#D4371C" },
          tooltip: (
            <>
              Formula: Rate = (w-µ) / µ <br />
              <br />
              w: the weekly usage for last complete week <br />
              µ: the average of all weekly usage from the last week to rolling 50 weeks which have
              usage
            </>
          ),
        },
        { label: "Site URL/CH Org", colId: "description" },
      ];
    case "HEALTH":
      return [...SHARED_CONFIG, { label: "Site URL", colId: "description" }];
    case "SUPPORT":
      return [...SHARED_CONFIG, { label: "Severity", colId: "description" }];
    // case "AEM_WEM":
    //   return [...SHARED_CONFIG, { label: "Reason", colId: "description" }];
  }
};

export const getExecutiveAlertIconListViewConfig = (
  type: "RENEWAL_ALERT" | "ACTIVE_RADIO_ALERT" | "SUPPORT_ALERT" | "RISK_CHANGED_ALERT"
): AlertIconListViewConfig<AlertDetail>[] => {
  switch (type) {
    case "RISK_CHANGED_ALERT":
      return [
        {
          label: "Current ORA",
          colId: "currORA",
        },
        {
          label: "Previous ORA",
          colId: "preORA",
        },
        {
          label: "Modified Date",
          colId: "lastModifiedDate",
          valueFormatter: function (value) {
            return moment(value).format("MM/DD/YYYY");
          },
        },
      ];
    case "RENEWAL_ALERT":
      return [
        {
          label: "Subscription Id",
          colId: "subscriptionId",
        },
        {
          label: "Renewal Date",
          colId: "renewDate",
          valueFormatter: function (value) {
            return moment(value).format("MM/DD/YYYY");
          },
        },
      ];
    case "ACTIVE_RADIO_ALERT":
      return [
        {
          label: "Percent",
          colId: "name",
          valueFormatter: (value: string) => `${value}%`,
        },
        {
          label: "Description",
          colId: "description",
          valueFormatter: function () {
            return " Active Host/Registered Host Ratio (Meetings)";
          },
        },
      ];
    case "SUPPORT_ALERT":
      return [...SHARED_CONFIG, { label: "Severity", colId: "description" }];
  }
};

export const getShowDetailByType = (type: AlertIconType) => (alertDetail: AlertDetail) => {
  switch (type) {
    case "CHURN_RISK":
      window.open(
        `/spng/summary?accountId=${alertDetail.accountId}&subscription=${alertDetail.referenceId}&section=${alertDetail.referenceId}Health`,
        "_blank"
      );
      break;
    case "HEALTH":
      window.open(
        `/spng/summary?accountId=${alertDetail.accountId}&subscription=${alertDetail.subscriptionId}&section=${alertDetail.subscriptionId}Sites&keyword=${alertDetail.description}`,
        "_blank"
      );
      break;
    case "SUPPORT":
      window.open(
        `/spng/summary/technical-support-information?accountId=${alertDetail.accountId}&incident-number=${alertDetail.referenceId}`,
        "_blank"
      );
      break;
    case "USAGE":
      window.open(
        `/spng/summary/usage/meeting?accountId=${alertDetail.accountId}&site=${
          alertDetail.description
        }${
          alertDetail.name === "Decline in # of Hosts" ? "#ActiveHostsChart" : "#TotalMeetingsChart"
        }`,
        "_blank"
      );
      break;
  }
};
